interface IValueLengthLimit {
  min?: number
  max?: number
}

export const getMessageInvalidLengthOfValue = (limit: IValueLengthLimit) => {
  let message = ''

  if (!(limit.min || limit.max)) {
    return message
  }

  const positiveStatement = 'Must contain'
  let min = limit.min ? Math.max(0, limit.min) : 0
  let max = limit.max ? Math.max(0, limit.max) : 0

  if (min && max) {
    min = Math.min(min, max)
    max = Math.max(min, max)
  }

  if (min && max) {
    message = `${positiveStatement} at least ${min} and less than ${max}`
  } else if (min) {
    message = `${positiveStatement} at least ${min}`
  } else if (max) {
    message = `${positiveStatement} less than ${max}`
  }

  return message ? `${message} characters` : message
}
